(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('ValuationApiCallDetailController', ValuationApiCallDetailController);

    ValuationApiCallDetailController.$inject = ['$uibModalInstance', 'entity', 'call', 'mode'];

    function ValuationApiCallDetailController($uibModalInstance, entity, call, mode) {
        var vm = this;

        vm.call = call;
        vm.content = entity ? entity.content : null;
        vm.mode = mode; // 'request' | 'response' | 'upstream' | 'upstream-request'
        var titleKeys = {
            'request': 'valuationApiCalls.detail.requestTitle',
            'response': 'valuationApiCalls.detail.responseTitle',
            'upstream': 'valuationApiCalls.detail.upstreamTitle',
            'upstream-request': 'valuationApiCalls.detail.upstreamRequestTitle'
        };
        vm.titleKey = titleKeys[mode] || 'valuationApiCalls.detail.responseTitle';
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
